import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { transactionsDemoData } from '../../../../data/transactionsDemoData';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { handleLoadPaymentsData } from './TransactionOperation';

const TransactionsContext = createContext();
export const useTransaction = () => useContext(TransactionsContext);

function TransactionsProvider({ children }) {
    const [reloadKey, setReloadKey] = useState(0);
    const [params, setParams] = useState({});
    const [transactionsData, setTransactionsData] = useState(transactionsDemoData);

    const { setMessage } = useTemplate();

    // -- Load all user list that are logged in
    useEffect(() => {
        setTransactionsData({ transactions: transactionsDemoData, pagination: {} });
        if (Object.keys(params).length > 0) {
            handleLoadPaymentsData(params)
                .then(({ data }) => {
                    setTransactionsData(data);
                })
                .catch((err) => {
                    setTransactionsData({ transactions: [], pagination: {} });
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        }
    }, [setMessage, reloadKey, params]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        return {
            // -- Reload Key
            reloadKey,
            setReloadKey,
            // -- Params
            params,
            setParams,
            // -- payment list data
            transactionsData,
            setTransactionsData,

            // All Handler
            handleReload
        };
    }, [transactionsData, params, reloadKey]);

    return <TransactionsContext.Provider value={value}>{children}</TransactionsContext.Provider>;
}

export default TransactionsProvider;
